import { render, staticRenderFns } from "./tcContent.vue?vue&type=template&id=3a84dbee&scoped=true&"
import script from "./tcContent.vue?vue&type=script&lang=js&"
export * from "./tcContent.vue?vue&type=script&lang=js&"
import style0 from "./tcContent.vue?vue&type=style&index=0&id=3a84dbee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84dbee",
  null
  
)

export default component.exports